import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import RadioButton from "./RadioButton";
import Typography from "../Typography/Typography";

import { getOptionKey } from "../../utils/select";

import styles from "./RadioGroup.module.scss";

const RadioGroup = ({
  options,
  value,
  onChange,
  className,
  isTranslateLabels,
  label,
  groupName = "radio-group",
  disabled: keysDisabled,
  colClassName,
  isInline,
  hideRadio,
  searchValue,
  onItemKeyDown,
}) => {
  const valueCurrentParsed = getOptionKey(value);

  const [currentId, setCurrentId] = useState(valueCurrentParsed);

  const handleChange = (value, e) => {
    onChange && onChange(value, e);
    setCurrentId(value);
  };

  return (
    <div
      role="radiogroup"
      aria-labelledby={groupName}
      className={classNames(
        "RadioGroup", styles["RadioGroup"], styles[colClassName], className
      )}
    >
      {label && (
        <Typography
          key="group-name"
          tag="div"
          variant={Typography.variant.body3}
          fontFamily={Typography.fontFamily.roboto}
          color={Typography.color.formLabelColor}
          className={styles["group-name"]}
        >{label}</Typography>
      )}
      {
        options?.length ? options.map((item, index) => {
          const { label, icon, style, isTranslateLabel, disabled } = item;
          const key = getOptionKey(item);
          const isDisabled = disabled ?? keysDisabled?.includes(key);

          const isSelected = key === currentId;

          return (
            <RadioButton
              key={key ?? index}
              style={style}
              icon={icon}
              onSelect={handleChange}
              onKeyDown={onItemKeyDown}
              isTranslateLabel={isTranslateLabel ?? isTranslateLabels}
              selected={isSelected}
              isInline={isInline}
              disabled={isDisabled}
              label={label}
              value={key}
              groupName={groupName}
              hideRadio={hideRadio}
              searchValue={searchValue}
            />
          );
        }) : ""
      }
    </div>
  );
};

RadioGroup.propTypes = {
  isInline: PropTypes.bool,
  hideRadio: PropTypes.bool,
  isTranslateLabels: PropTypes.bool,
  options: PropTypes.array,
  disabled: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  onChange: PropTypes.func,
  className: PropTypes.string,
  colClassName: PropTypes.string,
  groupName: PropTypes.string
};

export default RadioGroup;
